/**
 * Get information that is needed before authentication
 */

import { Injectable } from '@angular/core';

import { CommonRequestService } from './common-request.service';
import { AppSettings } from '../app.settings';
import { CommonUtilityService } from './common-utility';

export interface LBRole {
	default: boolean;
	desc: string;
	rol_id: number;
}

@Injectable()
export class AppinfoPreService {

	// columns info obtained from gdo
	public columnMap: any = {};
	public dict: any = {};

	public rolesByApp: {
		[prop: string]: LBRole[];
	} = {};

	constructor(
		private requestService: CommonRequestService,
		private utilityService: CommonUtilityService,
	) {}
	// Get information needed before login.
	getAppInfoPre(successCallback?, errorCallback?) {
		console.log('Service Called: getAppInfoPre.');
		return this.requestService.requestGet(AppSettings.serviceRootUrl + 'admin/appInfo', null,
			(rsp) => {
				this.setColumnMap(rsp.data.gdo);
				this.setRoles(rsp.data.roles);
				if (successCallback) {
					successCallback();
				}
			}, (err) => {
				if (errorCallback) {
					errorCallback();
				}
			},
			// no jwt needed
			true);
	}
	private setColumnMap(data) {
		if (!data) {
			console.log('No Gdo Info.');
			return;
		}
		for (let i = 0; i < data.result.length; i++) {
			this.columnMap[data.result[i].col_name] = {
				name: data.result[i].col_name, // column name
				heading: data.result[i].col_heading, // column displayed name
				width: data.result[i].col_size,
				type: data.result[i].col_type,
				sourceTab: data.result[i].src_tab, // source tab
				align: data.result[i].align, // text-align. 'C' for center, 'L' for left, 'R' for right
				isDisplay: data.result[i].display === 'Y' ? true : false , // display or hide column. 'Y' | 'N'
				isPrimeKey: data.result[i].prim_key === 'Y' ? true : false, // is prime key or not
				isGto: data.result[i].gto === 'Y' ? true : false, // ???
				seq: data.result[i].col_seq // column sequence
			};		}
	}

	private setRoles(data) {
		if (!data) { return; }
		this.rolesByApp = this.utilityService.arrayToObjectByFirstProp(data);
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/appinfo-pre.service.ts